/**
 * Mirrors ENUM_SYS_Appointment_Type in the Core enums. These are sent as
 * appointmentType on Create_Appointment / Update_Appointment.
 */
export const APPOINTMENT_TYPE = {
  UNKNOWN: 1,
  RESOURCE: 2,
  CALENDAR: 3,
  SERVICE_ORDER: 4,
  TASK: 5,
  DROP_IN: 6,
  FINISHED_TASK: 7,
} as const;

export type AppointmentTypeValue =
  (typeof APPOINTMENT_TYPE)[keyof typeof APPOINTMENT_TYPE];
